import PropTypes from "prop-types";
import React from "react";

// Segmented control for a layout choice. Defaults to grid vs. list density;
// callers can pass their own `options`.
const OPTIONS = [
  { value: "grid", label: "Grid", icon: "fa-table-cells-large" },
  { value: "list", label: "List", icon: "fa-list" },
];

export const ViewToggle = ({
  value,
  onChange,
  options = OPTIONS,
  ariaLabel = "Campaign layout",
}) => (
  <div className="cf-viewtoggle" role="tablist" aria-label={ariaLabel}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        role="tab"
        aria-selected={value === option.value}
        className={
          "cf-viewtoggle__btn" + (value === option.value ? " is-active" : "")
        }
        onClick={() => onChange(option.value)}
      >
        <i className={`fa-solid ${option.icon}`} aria-hidden="true" />
        <span className="cf-viewtoggle__label">{option.label}</span>
      </button>
    ))}
  </div>
);

ViewToggle.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    })
  ),
  ariaLabel: PropTypes.string,
};
